import {IPaylodAction, ISingleCreateDispatcher} from '../../interfaces/dispatchers'
import DataActions from '../../enums/ActionTypes/DataActions'
import {IStore} from '../../interfaces/reducers'
import {Feature} from '../../models'

export class SingleCreateDispatcher implements ISingleCreateDispatcher {
  constructor() {
    this.setSelectedFeature = this.setSelectedFeature.bind(this)
    this.removeSelection = this.removeSelection.bind(this)
  }
  public removeSelection() {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      dispatch({
        type: DataActions.SET_SINGLE_CREATE_SELECTED_FEATURE,
        payload: undefined
      })
    }
  }
  public setSelectedFeature(feature: Feature, id: string) {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      dispatch({
        type: DataActions.SET_SINGLE_CREATE_SELECTED_FEATURE,
        payload: {
          feature,
          id,
          loading: false
        }
      })
    }
  }
}
